import { animated, Transition } from 'react-spring/renderprops';

import { ShowHideProps } from './types';

const hiddenStyles = { height: 0 };
const DURATION = 400;

const ShowHide: React.FC<ShowHideProps> = ({ visible, children }) => (
  <Transition
    config={{ duration: DURATION }}
    enter={{ height: 'auto' }}
    from={hiddenStyles}
    items={visible}
    leave={hiddenStyles}
    native
  >
    {(show) => (styles) =>
      show && <animated.div style={{ ...styles, overflow: 'hidden' }}>{children}</animated.div>}
  </Transition>
);

export default ShowHide;
